import { render } from "./FrontofficeBudget.vue?vue&type=template&id=25e1a406&ts=true"
import script from "./FrontofficeBudget.vue?vue&type=script&lang=ts"
export * from "./FrontofficeBudget.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__